import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import {RouteEnumFinal} from "../Config/RouteEnum";
import AddressList from "./Address/AddressList";
import AddressAdd from "./Address/AddressAdd";
import ClearCache from "./ClearCache";
import GeneralStatistics from "./Statistics/GeneralStatistics";
import Login from "../pages/Auth/Login";
import Verify from "../pages/Auth/Verify";
import AuthName from "../pages/Auth/AuthName";
import Create from "../pages/Store/Create";
import Splash from "../pages/Splash";
import ShowOwnerMode from "../pages/Product/ShowOwnerMode";
import Show from "../pages/Product/Show";
import GalleryEdit from "../pages/Product/GalleryEdit";
import AddOrEdit from "../pages/Product/AddOrEdit";
import CategoryList from "../pages/Store/Panel/CategoryList";
import CategoryListSorting from "../pages/Store/Panel/CategoryListSorting";
import CategoryProductList from "../pages/Store/Panel/CategoryProductList";
import ProductsQuickEdit from "../pages/Store/Panel/ProductsQuickEdit";
import QRCodeGenerator from "../pages/Store/Panel/QRCodeGenerator";
import SocialListForOwner from "../pages/Store/Panel/SocialListForOwner";
import Gallery from "../pages/Store/Panel/Gallery";
import Guilds from "../pages/Store/Panel/Guilds";
import MainView from "../pages/MainView";
import ProductListSorting from "../pages/Store/Panel/ProductListSorting";

const MyRouter = () => {
    return(
        <div>
            <BrowserRouter>
                <Routes>
                    <Route path={RouteEnumFinal.SPLASH} element={<Splash />} />

                    <Route path={RouteEnumFinal.CLEAR_CACHE} element={<ClearCache />} />

                    <Route path={RouteEnumFinal.PRODUCT_SHOW} element={<Show />} />
                    <Route path={RouteEnumFinal.PRODUCT_SHOW_OWNER_MODE} element={<ShowOwnerMode />} />
                    <Route path={RouteEnumFinal.PRODUCT_GALLERY} element={<GalleryEdit />} />
                    <Route path={RouteEnumFinal.PRODUCT_EDIT} element={<AddOrEdit />} />
                    <Route path={RouteEnumFinal.PRODUCT_ADD} element={<AddOrEdit />} />
                    <Route path={RouteEnumFinal.PRODUCTS_QUICK_EDIT} element={<ProductsQuickEdit />} />
                    <Route path={RouteEnumFinal.PRODUCT_LIST_SORTING} element={<ProductListSorting />} />

                    <Route path={RouteEnumFinal.STORE_MAIN_VIEW} element={<MainView />} />
                    <Route path={RouteEnumFinal.QR_CODE_GENERATOR} element={<QRCodeGenerator />} />
                    <Route path={RouteEnumFinal.STORE_STATISTICS} element={<GeneralStatistics />} />
                    <Route path={RouteEnumFinal.STORE_GALLERY} element={<Gallery />} />

                    <Route path={RouteEnumFinal.ADDRESS_LIST} element={<AddressList />} />
                    <Route path={RouteEnumFinal.ADDRESS_EDIT} element={<AddressAdd />} />
                    <Route path={RouteEnumFinal.ADDRESS_ADD} element={<AddressAdd />} />

                    <Route path={RouteEnumFinal.SOCIAL_LIST} element={<SocialListForOwner />} />

                    <Route path={RouteEnumFinal.GUILD_LIST} element={<Guilds />} />

                    <Route path={RouteEnumFinal.CATEGORY_LIST} element={<CategoryList />} />
                    <Route path={RouteEnumFinal.CATEGORY_LIST_SORTING} element={<CategoryListSorting />} />
                    <Route path={RouteEnumFinal.CATEGORY_PRODUCT_LIST} element={<CategoryProductList />} />
                    <Route path={RouteEnumFinal.USER_PROFILE} element={<MainView />} />
                    <Route path={RouteEnumFinal.MAIN} element={<MainView />} />

                    <Route path={RouteEnumFinal.AUTH_LOGIN_PHONE} element={<Login />} />
                    <Route path={RouteEnumFinal.AUTH_LOGIN_VERIFY} element={<Verify />} />
                    <Route path={RouteEnumFinal.AUTH_LOGIN_NAME} element={<AuthName />} />

                    <Route path={RouteEnumFinal.AUTH_CREATE_STORE} element={<Create />} />

                    <Route path={RouteEnumFinal.STORE_PANEL} element={<MainView />} />

                </Routes>
            </BrowserRouter>
        </div>
    )
}

export default MyRouter